/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './scheduleAction.defs.js'
export * as $defs from './scheduleAction.defs.js'
